// ESM-Huelle fuer lib/scripts/components/CMP_CInput.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CInput (id)
{
    this.construct (id);

    this.name = "CInput";
    this.htmlType = "input";
    
    this.saveStyles = null;
    
    this.properties =
    {
        type: "all",
        maxLength: 99,
        sound: true, //"lib/sounds/beep1.wav",

        OKcallback:
        {
            cls: null,
            fnc: null
        },
        changeValueCallback:
        {
            cls: null,
            fnc: null
        },
        attributes:
        {
            value: "",
            maxlength: "50",
            readonly: "readonly"
        },
        styles:
        {
        },
        selectedStyles:
        {
        },
        events:
        {onKeyup: true,
            onBlur: true,
            onFocus: true,
            onMousedown: true
        }
    }
}

CInput.prototype = new CComponent;

CInput.prototype.onKeyup = function(event, parameters, eventObj)
{
return;
if (typeof eventObj==="undefined" || !eventObj){
	eventObj=document.activeElement;
	if (!eventObj){
		return;
	}
}
//    this.setValue(eventObj.which);
	this.gotKey();
}

/*CInput.prototype.onKeydown = function(event, parameters, eventObj)
{
    this.setValue(eventObj.which);
}

CInput.prototype.addEvents = function(e,me) {
 e.properties=me;
 /* e.gotKey=me.gotKey;
 e.gotOK=me.gotOK;
 e.gotBackspace=me.gotBackspace;
 e.gotClear=me.gotClear;

}*/

CInput.prototype.setValue = function(keyCode)
{
    switch (keyCode)
    {
        case "13":
            this.gotOK ()
            return;
            break;
        case "8":
            this.gotBackspace ();
            return;
            break;
    }

    if ((keyCode > 32 && keyCode < 127) || keyCode > 127)
        this.gotKey (String.fromCharCode (keyCode));
}

CInput.prototype.gotOK = function()
{
    if (this.properties.OKcallback.fnc)
        this.properties.OKcallback.fnc (this.properties.OKcallback.cls, this.id,
            this.properties.attributes.value);
}

CInput.prototype.gotKey = function(key)
{
    key = this.checkValue (key);

    this.properties.attributes.value = this.properties.attributes.value + key;
    this.reAttribute ();

    if (typeof this.properties.changeValueCallback.fnc == "function")
        this.properties.changeValueCallback.fnc (this.properties.changeValueCallback.cls);

    log.add(4, "Info", "Got key for input field: " + key + " (current input value: " +
        this.properties.attributes.value + ")", "");
}

CInput.prototype.gotBackspace = function()
{
    var newValue = this.properties.attributes.value;
    newValue = newValue.substr (0, newValue.length - 1);
    this.properties.attributes.value = newValue;
    this.reAttribute ();
    
    if (typeof this.properties.changeValueCallback.fnc == "function")
        this.properties.changeValueCallback.fnc (this.properties.changeValueCallback.cls);

    log.add(4, "Info", "Got backspace for input field (current input value: " +
        this.properties.attributes.value + ")", "");
}

CInput.prototype.gotClear = function()
{
    this.properties.attributes.value = "";
    this.reAttribute ();
    
    if (typeof this.properties.changeValueCallback.fnc == "function")
        this.properties.changeValueCallback.fnc (this.properties.changeValueCallback.cls);

    log.add(4, "Info", "Got clear for input field", "");
}


CInput.prototype.checkValue = function(key)
{
    switch (this.properties.type.toUpperCase())
    {
        case "MONEY":
            key = this.checkMoneyValue(key);
            break;
    }
    
    if (key == null)
    {
        //TODO: do something with input field?
        key = "";
    }
    
    return key;
}

CInput.prototype.checkMoneyValue = function(key)
{
    var splitVal = this.properties.attributes.value.toString().split(",");
    var digits = new Array(0, 0);
    
    for (window.i = 0; i < splitVal.length; window.i++)
        digits[i] = splitVal[i].length;
    
    if (key == parseInt(key))
    {
        if (digits[1] >= 2)
            key = null;
        else if (digits[1] >= 1 && key.length > 1)
            key = key.substr(0, 1);
    }
    else if (key == ",")
    {
        if (splitVal.length > 1)
            key = null;
            
        if (digits[0] == 0)
            key = "0,";
    }
/*
    if (key == "00" && splitVal.length < 2 && digits[0] > 0)
        key = ",00";
    else if (key == "00" && splitVal.length < 2 && digits[0] < 1)
        key = "0,00";
*/    
    return key;
}

CInput.prototype.onFocus = function(event, parameters, eventObj)
{
    POS.gotFocus (this.id);
    //this.saveStyles = this.properties.styles.toSource ();
	this.saveStyles = toSource(this.properties.styles);
    this.properties.styles = combine (this.properties.styles,
        this.properties.selectedStyles);
    this.reStyle();
}

CInput.prototype.onBlur = function(event, parameters, eventObj)
{
//    POS.lostFocus (this.id);
    //this.properties.styles = eval (this.saveStyles);
	this.properties.styles = JSON.parse (this.saveStyles);
    this.reStyle();
}

CInput.prototype.onMousedown = function(event, parameters, eventObj)
{
    POS.events.unlock();

    if (this.properties.sound)
        POS.sound.beep();

    this.gotClear();

    var element = document.getElementById(this.id);
    element.focus();
}

export { CInput };
